import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getRequirementFilterDataAction } from '../actions';

const {
  useLoaderData: useRequirementFiltersData,
  useLoader: useRequirementFiltersLoader,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({ action: getRequirementFilterDataAction });

function RequirementFiltersLoader({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  RequirementFiltersLoader,
  useRequirementFiltersData,
  useRequirementFiltersLoader,
};
